module.exports = __webpack_public_path__ + "img/bt6_act.1ee5e724.png";